export default "__VITE_ASSET__CNiHJlIP__"